// extracted by mini-css-extract-plugin
export default {"GameCreation":"GameCreation_GameCreation__VmDqg"};